import { roleBindingResourceParse } from '../../../authz/authz.functions';
import { RoleBinding } from '../../../authz/gen/ai/h2o/authorization/v1/role_binding_pb';
import { OwnerRoleKey } from '../../../authz/providers/RoleProvider';
import { workspaceIdFromName } from '../../../authz/utils';

export const isOwnerRoleBinding = ({ role }: RoleBinding) =>
  role === OwnerRoleKey.WORKSPACE_OWNER || role === OwnerRoleKey.PERSONAL_WORKSPACE_OWNER;

export const workspaceIdFromResource = (resource: string): string | undefined => {
  const parsedResource = roleBindingResourceParse(resource);
  return workspaceIdFromName(parsedResource);
};

export const groupRoleBindingsToGroupsAndUsers = (
  roleBindings: RoleBinding[]
): {
  users?: RoleBinding[];
  groups?: RoleBinding[];
  other?: RoleBinding[];
} => {
  const result: {
    users?: RoleBinding[];
    groups?: RoleBinding[];
    other?: RoleBinding[];
  } = {};

  for (const roleBinding of roleBindings) {
    const subject = roleBinding.subject;
    if (!subject) continue;

    if (subject.startsWith('users')) {
      if (!result.users) result.users = [];
      result.users.push(roleBinding);
    } else if (subject.startsWith('groups')) {
      if (!result.groups) result.groups = [];
      result.groups.push(roleBinding);
    } else {
      if (!result.other) result.other = [];
      result.other.push(roleBinding);
    }
  }

  return result;
};
